import {
  CareTeam as CareTeamProvider,
  FirebaseAuthenticated,
  RemoteI18nDataProvider,
  NotificationProvider,
  UserProfileProvider,
} from '@xolv-mybrightlink/mybrightlink';
import { ChangeUserPermissionAware } from '../pages/ChangeUserPermissionAware';
import {
  UserInfoProvider,
  Nested,
  AnalyticsIdentityProvider,
} from '@xolv-mybrightlink/common';
import { RootPage } from '../pages/RootPage';
import { Outlet } from 'react-router-dom';
import { Authenticated } from '@xolv-mybrightlink/security';

const AuthenticatedRoute = () => (
  <Nested
    components={[
      Authenticated,
      UserInfoProvider,
      FirebaseAuthenticated,
      ChangeUserPermissionAware,
      RemoteI18nDataProvider,
      NotificationProvider,
      UserProfileProvider,
      CareTeamProvider,
      AnalyticsIdentityProvider,
    ]}
  >
    <RootPage>
      <Outlet />
    </RootPage>
  </Nested>
);

export { AuthenticatedRoute };
